// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/tools/tools.js#2 $
'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tcTools
* @element ANY
* @description
* # tcTools
* Adds a tools menu to components, charts etc
*/
angular.module('tc.tools', [])
.controller('ToolsCtrl', function($window, $scope, $log, $location,
									GlobalService, WorkflowService, OverlayService, tcConstants) {

	const initialiseController = function() {
		$scope.globalStrings = GlobalService.getGlobalStrings();

		$scope.viewModel = {
			showingTools: GlobalService.globalContext.showingTools,
			allowComponentManager: isComponentManagerAllowed(),
			watcherLimits: {
				critical: tcConstants.MONITOR_LIMITS.WATCHERS.CRITICAL,
				warning: tcConstants.MONITOR_LIMITS.WATCHERS.WARNING,
			},
			...getLayoutRestrictions(),
		};
		$scope.tcDataObject = $scope.tcDataObject ? $scope.tcDataObject : $scope.$parent.data;
	};
	
	// Returns if Layout Editor/Picker access is allowed for the component,
	// based on the layout restrictions set against the user or group
	const getLayoutRestrictions = function() {
		const logonData = GlobalService.getLogonData();
		if (typeof logonData?.layoutRestrictions !== 'string') {
			return {
				allowLayoutEditor: true,
				allowLayoutPicker: true,
				showAdvancedTools: true
			};
		}
		const layoutRestrictions = logonData.layoutRestrictions.split(',');
		if (!layoutRestrictions.length) {
			return {
				allowLayoutEditor: true,
				allowLayoutPicker: true,
				showAdvancedTools: true
			};
		}
		
		let allowLayoutEditor = false;
		// Where layout restrictions exist, only allow defined components
		if (typeof $scope.tcToolsComponentName !== 'undefined') {
			if (layoutRestrictions.includes(tcConstants.LAYOUT_RESTRICTIONS.ALLOW_FLOORPLAN)
				&& ($scope.tcToolsComponentName === 'epr.floorplan')) {
					allowLayoutEditor = true;
			}
			if (layoutRestrictions.includes(tcConstants.LAYOUT_RESTRICTIONS.ALLOW_REPORT_PARAMETER)
				&& ($scope.tcToolsComponentName === 'webcommon.Report.Custom')) {
					allowLayoutEditor = true;
			}
			if (layoutRestrictions.includes(tcConstants.LAYOUT_RESTRICTIONS.ALLOW_QUESTIONNAIRE)
				&& ($scope.tcToolsComponentName.startsWith('questionnaire.Q'))) {
					allowLayoutEditor = true;
			}
		}
		// Layout Picker is allowed if Layout Editor is allowed from the above, or it is allowed explicitly in Layout Restrictions
		const allowLayoutPicker = (allowLayoutEditor
			|| layoutRestrictions.includes(tcConstants.LAYOUT_RESTRICTIONS.ALLOW_LAYOUT_PICKER));
		
		return {
			allowLayoutPicker,
			allowLayoutEditor,
			showAdvancedTools: false,
		};
	};
	
	// Returns whether Component Manager should be accessible on this environment and for this component
	const isComponentManagerAllowed = function() {
		// Non-standard (e.g. chart) toolbars or locked down components will not pass id
		if (!$scope.tcToolsComponentId) return false;

		const logonData = GlobalService.getLogonData();
		return (logonData.allowComponentManager === true);
	};
	
	// Catch Global:toggleTools event broadcast by GlobalService
	$scope.$on('Global:toggleTools', function($event, newShowingTools) {
		$scope.viewModel.showingTools = newShowingTools;
		if (!newShowingTools && $scope.tcViewModel?.developerMode) {
			$scope.tcViewModel.developerMode = false;
		}
	});
	
	const openUrl = function(url) {
		OverlayService.close();
		GlobalService.updateBannerData({});
		$location.url(WorkflowService.getNextLevelUrl(url));
	};

	$scope.layoutEdit = function() {
		openUrl($scope.tcLayoutEditUrl);
	};
	
	$scope.openLayoutPicker = function(url) {
		openUrl(url);
	};

	$scope.openPerfExplorer = function() {
		const url = GlobalService.maskUrl('/Component/websys.MonitorPerformance.Session');
		openUrl(url);
	};
	
	$scope.openComponentManager = function() {
		let url = 'websys.default.csp?WEBSYS.TCOMPONENT=websys.ComponentMgr.Composite';
		url += ('&name=' + $scope.tcToolsComponentName + '&PARREF=' + $scope.tcToolsComponentId);
		url = GlobalService.maskUrl(url);
		openUrl(url);
	};

	$scope.dumpData = function() {
		if (typeof $scope.tcDataObject !== 'undefined') {
			$log.log($scope.tcDataObject);
		}
		if (typeof $scope.tcViewModel !== 'undefined') {
			$log.log('viewModel: ', $scope.tcViewModel);
		}
	};
	
	$scope.$on('Global:userLogon', function(event, sessionData) {
		$scope.globalStrings = sessionData.globalStrings;
	});
	
	initialiseController();
})
.directive('tcTools', function() {
	return {
		templateUrl: 'template/tools/tools.html',
		restrict: 'E',
		controller: 'ToolsCtrl',
		scope: {
			tcLayoutPickerUrl: '@',
			tcDataLayoutPickerUrl: '@',
			tcLayoutEditUrl: '@',
			tcModelClassName: '@',
			tcContext: '@',
			tcViewModel: '=',
			tcWatchersCount: '=',
			tcDataObject: '=?',
			id: '@',
			tcToolsComponentName: '@',
			tcToolsComponentId: '@',
		},
	};
})
.filter('tcToolsHighlightComponent', function() {
	// Filter that highlights the component name within the model class name
	return function(modelClassName, componentName) {
		if (angular.isUndefined(modelClassName)) return modelClassName;
		
		const componentRegExp = RegExp('\\.' + componentName, 'g');
		return modelClassName.replace(componentRegExp, '.<b>' + componentName + '</b>');
	};
});
